import { Component, Inject, ViewChild } from '@angular/core';
import { GlobalVariablesService } from '@services/global-variables/global-variables.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GlobalVariablesEditComponent } from '../global-variables-edit/global-variables-edit.component';
import { DataTableComponent } from '../../../components/data-table/data-table.component';

@Component({
  selector: 'app-global-variables-select',
  templateUrl: './global-variables-select.component.html',
  styleUrl: './global-variables-select.component.scss',
  providers: [GlobalVariablesService],
  standalone: false
})
export class GlobalVariablesSelectComponent {
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  columns = [{ prop: 'name', title: 'Name' }];
  headerButtons = [{ icon: 'add', callback: () => this.add() }];

  constructor(
    public dialogRef: MatDialogRef<GlobalVariablesSelectComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public varService: GlobalVariablesService, private dialog: MatDialog
  ) {
  }

  async add() {
    let dialogRef: MatDialogRef<GlobalVariablesEditComponent>;
    dialogRef = this.dialog.open(GlobalVariablesEditComponent, {});
    const res = await dialogRef.afterClosed().toPromise();
    if (res) {
      await this.varService.create(res);
      return this.dataTable.page();
    }
  }

  select(event: any) {
    if (event?.row) {
      this.dialogRef.close(event.row);
    }
  }
}
